import React from 'react';

import { SidePage } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import {
  useConceptFamilyDetails,
  useIsUpdating,
} from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';
import { TAB_DETAILS } from 'scenes/Gallery/GalleryPage/constants';

import AttachmentsTab from './components/AttachmentsTab';
import ConceptFamilyDetails from './ConceptFamilyDetails';

const ConceptFamilyDetailsSidePage = ({
  id,
  activeTabId = TAB_DETAILS,
  onClose,
  onExited,
  open,
}) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const { isAllowAttachments } = useGalleryPermissions();

  const { data, isLoading, isRefetching } = useConceptFamilyDetails({ id });
  const isUpdating = useIsUpdating();

  const handleDelete = async () => {
    onClose();
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Concept Family'}
        subTitle={data?.name}
        entityId={id}
      />
      <SidePage.Tabs activeTabId={activeTabId}>
        <SidePage.Tab label={TAB_DETAILS} data-cy-label={'Details'}>
          {!!data && (
            <ConceptFamilyDetails
              data={data}
              onDelete={handleDelete}
              openChildComponent={openChildComponent}
            />
          )}
        </SidePage.Tab>
        {isAllowAttachments ? <AttachmentsTab conceptFamilyId={id} /> : null}
      </SidePage.Tabs>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default ConceptFamilyDetailsSidePage;

export { default as ConceptFamilyDetailsGeneral } from './ConceptFamilyDetailsGeneral';
export { default as ConceptFamilyDetailsInfo } from './ConceptFamilyDetailsInfo';
